import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { palette, transitions, breakpoints, functions } = theme;
  const { transparentSidenav, whiteSidenav, miniSidenav, darkMode } = ownerState;

  const sidebarWidth = 224;
  const { transparent, white, background, borderColor } = palette;
  const { pxToRem } = functions;

  // Redesign: neutral surface sidenav (white / dark #171E29), 1px right hairline, flat.
  // The template's blue gradient is retired. transparent/white modes preserved.
  let backgroundValue = darkMode ? background.sidenav : white.main;

  if (transparentSidenav) {
    backgroundValue = transparent.main;
  } else if (whiteSidenav) {
    backgroundValue = white.main;
  }

  const borderRightValue = transparentSidenav ? "none" : `1px solid ${borderColor.main}`;

  // styles for the sidenav when miniSidenav={false}
  const drawerOpenStyles = () => ({
    background: backgroundValue,
    transform: "translateX(0)",
    overflowX: "hidden",
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("navOverlay")]: {
      boxShadow: "none",
      marginBottom: "inherit",
      left: "0",
      width: sidebarWidth,
      overflowX: "hidden",
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },
  });

  // styles for the sidenav when miniSidenav={true}
  const drawerCloseStyles = () => ({
    background: backgroundValue,
    transform: `translateX(${pxToRem(-320)})`,
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("navOverlay")]: {
      boxShadow: "none",
      marginBottom: "inherit",
      left: "0",
      width: pxToRem(80),
      overflowX: "hidden",
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
    },
  });

  return {
    "& .MuiDrawer-paper": {
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      boxShadow: "none",
      border: "none",
      borderRight: borderRightValue,

      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },
  };
});
